export class FlightDataMaster {
  id?: number;
  flightDataCompressedStr: string;
  flightDataName?: string;
  bidType?: string;
  flightdataVersionNumber?: string;
}
